import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Universitat } from '../model/Universitat';
import { Pais } from '../model/pais';
import { Injectable } from '@angular/core';

@Injectable()
export class BLFitxer {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    upload(file: FormData): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.http.post<number>(this.dataService.getApiEndpoint('fitxer'), file).subscribe(data => {
                resolve(data);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/blfitxer.ts